import {useTranslation} from "react-i18next"
import React, {useState} from "react"
import ApiService from "@bodeboca/api"
import CommonUtils from "@bodeboca/utils"
import StockAlert from "@bodeboca/flag/components/stockAlert/stock-alert"
import AddToCart from "@bodeboca/algolia/components/wineblock/add-to-cart"

type Props = {
  hit: any;
  sendEvent: any;
  userFlaggedItems: any;
  availableBundlesToFlag: any;
};

const WineBoxBottom = ({hit, sendEvent, userFlaggedItems, availableBundlesToFlag}: Props) => {
  const [amount, setAmount] = useState(1)
  const languageInfo = hit[CommonUtils.getCurrentLanguage()] !== undefined ? hit[CommonUtils.getCurrentLanguage()] : hit['es']


  function isFlaggable(): boolean{

    return (
      availableBundlesToFlag.includes(hit.node_type) &&
      hit.hasOwnProperty('brand') &&
      hit.brand !== ''
    )
  }

  const agotado = hit.stock_count < 1
  const {t} = useTranslation()

  return (<div className="winebox-bottom">
    {agotado && <div className="add-to-cart">
      <div className="agotado">{t("Out of stock")}</div>
      { isFlaggable() &&
        <StockAlert
          availableBundlesToFlag={availableBundlesToFlag}
          product={hit}
          userFlaggedItems={userFlaggedItems}/>}
    </div>}
    {!agotado && <AddToCart 
      hit={hit} 
      productId={hit.product_id} 
      queryID={hit.__queryID}
      sendEvent={sendEvent}
      title={languageInfo["title"]}/>}
  </div>)
}
export default WineBoxBottom
